import React from 'react';

import TextParseComponent from 'components/feed/TextParseComponent';
import { components } from 'react-select';
import styled from 'styled-components';

const StyledGoalParserComponent = styled.div`
  cursor: default;
  padding: 0.5rem;
`;

const GoalParsedSingleValue = (props) => {
  const { data } = props;
  return (
    <components.SingleValue {...props}>
      <StyledGoalParserComponent>
        <TextParseComponent text={data.label} res={data.macros} />
      </StyledGoalParserComponent>
    </components.SingleValue>
  );
};

export default GoalParsedSingleValue;
